module.exports = __webpack_public_path__ + "static/media/pattern11.093c1071.svg";